<template>
  <div class="vx-col w-full mb-base m-auto" id="parentx-demo-1">
    <vs-sidebar
      position-right
      parent="body"
      default-index="1"
      color="primary"
      class="sidebarx sidesheet"
      spacer
      v-model="active"
      v-if="sidebarUserData"
    >
      <div class="header-sidebar" slot="header">
        <vs-button
          class="float-left"
          color="#EA5455"
          type="border"
          icon-pack="feather"
          icon="icon-x"
          @click="CloseSlidebar()"
          v-bind:style="{ left: '170px'}"
        ></vs-button>
        <!--  <vs-avatar  size="70px" :src="require(`@/assets/images/portrait/small/avatar-s-11.png`)"/>-->
        <vs-avatar
          class="m-0"
          :src="sidebarUserData.profile_image"
          size="50px"
          v-if="sidebarUserData.profile_image"
        />
        <vs-avatar
          color="primary"
          class="m-0 name-avatar"
          :text="usernameList(sidebarUserData.firstname,sidebarUserData.lastname)"
          size="50px"
          v-else
        />

        <h4>
          {{ sidebarUserData.user_name }}
          <!-- <vs-button color="primary" icon="more_horiz" type="flat"></vs-button> -->
        </h4>
        <div v-if="sidebarUserData.users_in_out">
          <h6 class="mt-1">
            <b>Status :-</b>
            <span v-if="sidebarUserData.users_in_out.status == 'IN'">IN</span>
            <span v-if="sidebarUserData.users_in_out.status == 'OUT'">OUT</span>
            <span v-if="sidebarUserData.users_in_out.status == 'BI'">Break</span>
            <span
              v-if="sidebarUserData.users_in_out.comment"
            >({{sidebarUserData.users_in_out.comment}})</span>
          </h6>
          <h6 class="mt-1">
            <b>Last Updated Date :-</b>
            {{sidebarUserData.users_in_out.start_time | moment('timezone',$store.state.uInfo.timeZone, 'DD/MM/YYYY') }}
          </h6>
          <h6 class="mt-1">
            <b>Last Updated Time :-</b>
            {{sidebarUserData.users_in_out.start_time | moment('timezone',$store.state.uInfo.timeZone, 'h:mm:ss a') }}
          </h6>
          <h6 class="mt-1">
            <b>TimeZone :-</b>
            {{sidebarUserData.timeZone}}
          </h6>
        </div>
      </div>
      <div class="w-full" v-if="!addTimesheet && !editTimesheet && !deleteTimesheet">
        <h5 class="float-left ml-4 mt-3">
          <b>
            Viewing Timesheet For
            {{addTimeDate | moment('timezone',$store.state.uInfo.timeZone, 'DD/MM/YYYY')}}
          </b>
        </h5>
        <vs-button
          class="float-right mb-5"
          color="primary"
          type="border"
          icon-pack="feather"
          icon="icon-plus"
          title="Add Time"
          v-if="!addTimesheet && !editTimesheet && !deleteTimesheet"
          @click="openAddForm()"
          v-bind:style="{ right: '20px',}"
        ></vs-button>
      </div>
      <form
        data-vv-scope="addtimesheet-form"
        class="vx-row mb-2 w-full ml-0 mt-12"
        v-if="addTimesheet"
      >
        <h3 class="w-full text-center p-2">Add Timesheet</h3>
        <div class="vx-col md:w-1/1 form-group w-full mb-2">
          <label for class="vs-input--label">Date</label>
          <datepicker
            placeholder="Select Date" :calendar-button="true" calendar-button-icon="fa fa-calendar"
            class="w-full calendar-icon-right top-45"
            :disabled="true"
            format="dd/MM/yyyy"
            v-model="addTimeDate"
            :value="sidebarUserData.users_in_out.start_time"
            @change="dateweek()"
          ></datepicker>
        </div>
        <div class="vx-col md:w-1/1 form-group w-full">
          <label for class="vs-input--label">Time</label>
          <!-- <flat-pickr class="vs-inputx vs-input--input normal time" :config="configdateTimePicker" v-model="addTime" v-validate="'required'"  name="time" placeholder="Choose in time" /> -->
          <input
            class="vs-inputx vs-input--input normal time-input"
            type="time"
            name="usr_time"
            v-model="addTime"
          />
          <span
            v-show="errors.has('addtimesheet-form.time')"
            class="text-danger text-sm block"
          >{{ errors.first('addtimesheet-form.time') }}</span>
        </div>
        <div class="vx-col md:w-1/1 form-group w-full">
          <label class="vs-input--label">Status</label>
          <ul class>
            <li class="m-2 inline-flex">
              <vs-radio name="status" v-model="addStatus" v-validate="'required'" :vs-value="'CIN'">
                Clock
                ON
              </vs-radio>
            </li>
            <li class="m-2 inline-flex">
              <vs-radio
                name="status"
                v-model="addStatus"
                v-validate="'required'"
                :vs-value="'COUT'"
              >
                Clock
                OFF
              </vs-radio>
            </li>
            <li class="m-2 inline-flex">
              <vs-radio
                name="status"
                v-model="addStatus"
                v-validate="'required'"
                :vs-value="'BI'"
              >Break Start</vs-radio>
            </li>
            <li class="m-2 inline-flex">
              <vs-radio
                name="status"
                v-model="addStatus"
                v-validate="'required'"
                :vs-value="'BS'"
              >Break End</vs-radio>
            </li>
          </ul>
          <span class="text-danger text-sm">{{ errors.first('addtimesheet-form.status') }}</span>
        </div>
        <div class="vx-col md:w-1/1 form-group w-full">
          <label class="vs-input--label" for>Note</label>
          <vs-input
            class="w-full"
            v-validate="'max:50'"
            name="comment"
            v-model="comment"
            autocomplete="off"
          />
          <span class="text-danger text-sm">{{ errors.first('addtimesheet-form.comment') }}</span>
        </div>
        <div class="vx-col md:w-1/1 form-group w-full">
          <vs-button
            class="mt-6 mr-5 gradient-btn shadow-lg m-auto remove-contact-person"
            @click.prevent="addTimeData()"
            size="medium"
          >Add</vs-button>
          <vs-button class="mt-1 ml-4 m-auto gradient-btn" @click.prevent="cancelAddForm()">Cancel</vs-button>
        </div>
      </form>
      <form
        data-vv-scope="edittimesheet-form"
        class="vx-row mb-2 w-full ml-0 mt-12"
        v-if="editTimesheet"
      >
        <h3 class="w-full text-center p-2">Edit Timesheet</h3>
        <div class="vx-col md:w-1/1 form-group w-full mb-2">
          <label class="vs-input--label" for>Date</label>
          <datepicker :calendar-button="true" calendar-button-icon="fa fa-calendar"
            placeholder="Select Date"
            :disabled="true"
            class="w-full calendar-icon-right top-45"
            format="dd/MM/yyyy"
            v-model="editTimeDate"
            @change="dateweek()"
          ></datepicker>
        </div>
        <div class="vx-col md:w-1/1 form-group w-full">
          <label class="vs-input--label" for>Time</label>

          <!-- <flat-pickr class="vs-inputx vs-input--input normal time" :config="configdateTimePicker" v-model="editTime" v-validate="'required'"  name="editTime" placeholder="Choose in time" /> -->
          <input
            class="vs-inputx vs-input--input normal time-input"
            type="time"
            name="usr_time"
            v-model="editTime"
          />
        </div>
        <div class="vx-col md:w-1/1 form-group w-full mt-2">
          <label class="vs-input--label" for>Note</label>
          <vs-input
            class="w-full"
            v-validate="'max:50'"
            name="comment"
            v-model="comment"
            autocomplete="off"
          />
          <span class="text-danger text-sm">{{ errors.first('edittimesheet-form.comment') }}</span>
        </div>
        <div class="vx-col md:w-1/1 form-group w-full">
          <vs-button
            class="mt-6 mr-5 shadow-lg m-auto remove-contact-person gradient-btn"
            @click.prevent="editTimeData()"
            size="medium"
          >Save</vs-button>
          <vs-button class="mt-1 ml-4 m-auto gradient-btn" @click.prevent="cancelEditForm()">Cancel</vs-button>
        </div>
      </form>
      <div
        class="vx-col md:w-1/1 form-group w-full delete-timesheet text-center mt-12"
        v-if="deleteTimesheet"
      >
        <div class="w-full">
          <h5>Are you sure you want to delete the timesheet?</h5>
        </div>
        <div class="w-full">
          <vs-button
            class="mt-6 shadow-lg m-auto remove-contact-person"
            color="danger"
            @click.prevent="deleteTimeSheet()"
            size="small"
          >Delete</vs-button>
          <vs-button
            class="ml-4 m-auto gradient-btn"
            size="small"
            @click.prevent="cancleDelete()"
          >Cancel</vs-button>
        </div>
      </div>
      <!-- <p>{{sidebarUserData.users_data}}</p> -->
      <vs-table
        :data="sidebarUserData.users_data"
        :disabled="true"
        v-if="!addTimesheet && !editTimesheet && !deleteTimesheet"
      >
        <template slot="thead">
          <vs-th>Status</vs-th>
          <vs-th>Time</vs-th>
          <vs-th>Updated By</vs-th>
          <vs-th>Action</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr
            :data="tr"
            :key="indextr"
            v-for="(tr, indextr) in data"
            v-if="checkTimesheetDate(tr.start_time,addTimeDate)"
          >
            <vs-td>{{ tr.status }}</vs-td>
            <vs-td>
              <!-- {{tr.start_time |  moment('timezone',$store.state.uInfo.timeZone, 'h:mm:ss a') }} -->
              {{tr.start_time | moment('timezone',sidebarUserData.timeZone, 'h:mm a') }}
            </vs-td>
            <vs-td>{{tr.updated_by ? tr.updated_by : '--' }}</vs-td>
            <vs-td>
              <vs-button
                class="float-left"
                color="primary"
                type="flat"
                icon-pack="feather"
                title="Edit Time"
                icon="icon-edit-2"
                @click="editTimeForm(tr)"
              ></vs-button>
              <vs-button
                color="danger"
                type="flat"
                icon-pack="feather"
                title="Delete Time"
                icon="icon-trash-2"
                @click="confirmDelete(tr._id)"
              ></vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-sidebar>
    <vx-card>
      <vs-tabs v-model="mainTab" class="activity-tabs">
        <vs-tab label="Users Timesheet">
          <div>
            <form autocomplete="off">
              <div class="datepicker-main mb-4">
                <div class="datewrapper justify-end w-full" v-if="$store.state.uInfo.role !== 'U'">
                  <vs-input
                    icon-pack="feather"
                    icon="icon-search"
                    v-model="search"
                    class="w-auto mr-1"
                  />
                  <v-select
                    :clearable="false"
                    @input="changeOffice()"
                    class="w-auto mr-1  min-150"
                    label="office_name"
                    :options="allOffices"
                    v-model="officeID"
                  ></v-select>
                  <v-select
                    v-if="officeID && officeID.id != 'all'"
                    :clearable="false"
                    multiple
                    class="w-auto min-150"
                    label="department_name"
                    :options="departments"
                    v-model="department_id"
                    @input="changeDept()"
                  ></v-select>
                </div>
              </div>
            </form>
          </div>
          <vs-tabs v-model="tab" alignment="center" class="all-tabs set_min_height">
            <vs-tab label="Day">
              <div class="mt-5 mb-5">
                <vs-table
                  ig="mytable"
                  :data="searchresult"
                  pagination
                  :max-items="perPage1"
                  class="stickyCol-tbl dayinout-tbl"
                >
                  <template slot="header">
                    <div class="datepicker-main">
                      <div class="datewrapper">
                        <label for class="float-right w-auto">Select Date</label>
                        <datepicker :calendar-button="true" calendar-button-icon="fa fa-calendar"
                          placeholder="Select Date"
                          class="float-right calendar-icon-right top-45"
                          format="dd/MM/yyyy"
                          v-model="currentDate"
                          @on-change="getNewDailyTimeSheet()"
                          :disabledDates="disabledDates"
                        ></datepicker>
                      </div>
                    </div>
                    <div class="flex mb-4">
                      <vue-json-to-csv :json-data="csvData" :csv-title="'DaysData'">
                        <vs-button class="gradient-btn">
                          <feather-icon icon="DownloadIcon" title="Download CSV" class></feather-icon>
                        </vs-button>
                      </vue-json-to-csv>
                      <vs-button
                        class="ml-1 gradient-btn"
                        target="_blank"
                        title="Download PDF"
                        @click="generatePDF"
                      >
                        <feather-icon icon="FileTextIcon" class></feather-icon>
                      </vs-button>
                    </div>
                  </template>
                  <template slot="thead">
                    <vs-th style="width: 20%;" class="sticky-col user-col">User</vs-th>
                    <vs-th style="width: 10%;" class="sticky-col clockin-col">Clock ON</vs-th>
                    <vs-th style="width: 10%;" class="sticky-col clockout-col">Clock OFF</vs-th>
                    <vs-th style="width: 10%;" class="sticky-col total-col">Total Time</vs-th>
                    <vs-th v-if="$store.state.uInfo.role == 'U'" style="width: 10%;" class="sticky-col total-col">Break Start</vs-th>
                    <vs-th
                      v-if="$store.state.uInfo.role == 'U'"
                      style="width: 10%;"
                      class="sticky-col total-col"
                    >Break End</vs-th>
                    <vs-th style="width: 10%;" class="sticky-col total-col">Break Total</vs-th>
                    <vs-th v-if="$store.state.uInfo.role !== 'U'" class="sticky-col" style="width: 10%;">Approved</vs-th>
                    <vs-th
                      v-if="$store.state.uInfo.role !== 'U'"
                      class="sticky-col"
                      style="width: 30%;"
                    >Comments</vs-th>
                    <!-- <vs-th style="width: 10%;">Action</vs-th> -->
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
                      <vs-td class="sticky-col user-col">
                        <div @click="openSlidebar(tr._id,currentDate)">
                          <div class="relative inline-flex float-left">
                            <vs-avatar
                              class="m-0"
                              :src="tr.profile_image"
                              size="40px"
                              v-if="tr.profile_image"
                            />
                            <vs-avatar
                              color="primary"
                              class="m-0 name-avatar"
                              :text="usernameList(tr.firstname,tr.lastname)"
                              size="40px"
                              v-else
                            />
                            <div
                              class="h-3 w-3 border-white border border-solid rounded-full absolute pin-r pin-b"
                              :class="'bg-success'"
                            ></div>
                          </div>
                          <h6 class="pt-3 ml-16 break-words">{{ tr.user_name | capitalize }}</h6>
                        </div>
                      </vs-td>
                      <vs-td :key="indextr" class="sticky-col clockin-col">
                        <span v-if="tr.cin">{{tr.cin.start_time | moment('h:mm a') }}</span>
                        <span v-else>00:00</span>
                      </vs-td>
                      <vs-td :key="indextr" class="sticky-col clockout-col">
                        <span v-if="tr.cout">{{tr.cout.start_time | moment('h:mm a') }}</span>
                        <span v-else>00:00</span>
                      </vs-td>
                      <vs-td
                        :key="indextr"
                        class="sticky-col total-col"
                      >{{ convertToTime(tr.totalActiveMinutes) }}</vs-td>
                      <vs-td
                        v-if="$store.state.uInfo.role == 'U'"
                        :key="indextr"
                        class="sticky-col total-col"
                      >
                        <span v-if="tr.bi">{{tr.bi.start_time | moment('h:mm a') }}</span>
                        <span v-else>00:00</span>
                      </vs-td>
                      <vs-td
                        v-if="$store.state.uInfo.role == 'U'"
                        :key="indextr"
                        class="sticky-col total-col"
                      >
                        <span v-if="tr.bs">{{tr.bs.start_time | moment('h:mm a') }}</span>
                        <span v-else>00:00</span>
                      </vs-td>
                      <vs-td
                        :key="indextr"
                        class="sticky-col total-col"
                      >{{convertToTime(tr.totalBreakMinutes)}}</vs-td>
                      <!-- <vs-td :key="indextr">
                                        <vs-button color="primary" type="border" icon-pack="feather" icon="icon-plus"
                                            title="Add Time" @click="openSlidebar(tr._id,currentDate)"></vs-button>
                      </vs-td>-->
                      <vs-td>
                        <vs-chip color="success" v-if="tr.isUnApprovedEditesThere">Approved</vs-chip>
                        <div v-else>
                          <feather-icon icon="CheckIcon" class="rounded p-3 inline-flex text-success" ></feather-icon>
                        </div>
                      </vs-td>
                      <vs-td>{{  tr.editComments }}</vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </vs-tab>
            <vs-tab label="Week">
              <div class="mt-5 mb-5">
                <vs-table :data="weeklySearchresult" pagination :max-items="perPage1">
                  <template slot="header">
                    <div class="datepicker-main">
                      <div class="datewrapper">
                        <label for class="float-right w-auto">Select Week Date</label>
                        <datepicker :calendar-button="true" calendar-button-icon="fa fa-calendar"
                          placeholder="Select Date"
                          class="float-right calendar-icon-right top-45"
                          format="dd/MM/yyyy"
                          v-model="date"
                          @change="dateweek()"
                          :disabledDates="disabledDates"
                        ></datepicker>
                      </div>
                    </div>
                    <div class="flex mb-4">
                      <vue-json-to-csv :json-data="csvWeekData" :csv-title="'WeekData'">
                        <vs-button class="gradient-btn">
                          <feather-icon icon="DownloadIcon" title="Download CSV" class></feather-icon>
                        </vs-button>
                      </vue-json-to-csv>
                      <vs-button
                        class="ml-1 gradient-btn"
                        target="_blank"
                        title="Download PDF"
                        @click="generateWeekPDF"
                      >
                        <feather-icon icon="FileTextIcon" class></feather-icon>
                      </vs-button>
                    </div>
                    <div v-if="$store.state.uInfo.role !== 'U'" class="total-hours">
                      Total Hours:
                      <span class="font-bold">{{totalActiveMinutesOfWeek}}</span>
                    </div>
                  </template>
                  <template slot="thead">
                    <vs-th>User</vs-th>
                    <vs-th v-for="(dates,index) in WeekDates" :key="index">
                      {{ dates.Date }}
                      <br />
                      {{ dates.Day }}
                    </vs-th>
                    <vs-th>Total Time</vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                      <vs-td>
                        <div class="relative inline-flex float-left">
                          <!--<vs-avatar class="m-0" :src="require(`@/assets/images/portrait/small/avatar-s-11.png`)" size="40px"/>-->
                          <vs-avatar
                            class="m-0"
                            :src="tr.profile_image"
                            size="40px"
                            v-if="tr.profile_image"
                          />
                          <vs-avatar
                            color="primary"
                            class="m-0 name-avatar"
                            :text="usernameList(tr.firstname,tr.lastname)"
                            size="40px"
                            v-else
                          />
                          <div
                            class="h-3 w-3 border-white border border-solid rounded-full absolute pin-r pin-b"
                            :class="'bg-success'"
                          ></div>
                        </div>
                        <h6 class="mt-2 ml-16 break-words">{{ tr.user_name | capitalize }}</h6>
                      </vs-td>
                      <vs-td v-for="(times,index) in tr.dateWiseData" :key="index">
                        <vx-tooltip text="View timesheet details">
                          <div class="time-box" @click="openSlidebar(tr.user_id,times.date)">
                            <span>{{convertToTime(times.activeMinutes)}}</span>
                          </div>
                        </vx-tooltip>
                      </vs-td>
                      <vs-td>{{ convertToTime(tr.totalActiveMinutes) }}</vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </vs-tab>
            <vs-tab label="Month">
              <div class="mt-5 mb-5 vx-row">
                <div class="vx-col w-full mb-4 text-right" v-if="$store.state.uInfo.role == 'U'">
                  <div>
                    <vue-json-to-csv :json-data="csvMonthData" :csv-title="'MonthData'">
                      <vs-button class="gradient-btn">
                        <feather-icon icon="DownloadIcon" title="Download CSV" class></feather-icon>
                      </vs-button>
                    </vue-json-to-csv>
                    <vs-button
                      class="ml-1 gradient-btn"
                      target="_blank"
                      title="Download PDF"
                      @click="generateMonthPDF"
                    >
                      <feather-icon icon="FileTextIcon" class></feather-icon>
                    </vs-button>
                  </div>
                </div>
                <div :class="$store.state.uInfo.role !== 'U' ? 'vx-col w-full' : 'vx-col w-1/2'">
                  <vs-table
                    :data="monthlySearchresult"
                    :pagination="$store.state.uInfo.role !== 'U'"
                    :max-items="perPage1"
                    class="stickyCol-tbl monthinout-tbl"
                  >
                    <template slot="header" v-if="$store.state.uInfo.role !== 'U'">
                      <div class="datepicker-main">
                        <div class="datewrapper">
                          <label for class="float-right w-auto">Select Month</label>
                          <datepicker :calendar-button="true" calendar-button-icon="fa fa-calendar"
                            placeholder="Select Date"
                            class="float-right calendar-icon-right top-45"
                            format="MMMM"
                            :minimumView="'month'"
                            :maximumView="'month'"
                            v-model="currentMonth"
                            :disabledDates="disabledDates"
                          ></datepicker>
                        </div>
                      </div>
                      <div>
                        <vue-json-to-csv :json-data="csvMonthData" :csv-title="'MonthData'">
                          <vs-button class="gradient-btn">
                            <feather-icon icon="DownloadIcon" title="Download CSV" class></feather-icon>
                          </vs-button>
                        </vue-json-to-csv>
                        <vs-button
                          class="ml-1 gradient-btn"
                          target="_blank"
                          title="Download PDF"
                          @click="generateMonthPDF"
                        >
                          <feather-icon icon="FileTextIcon" class></feather-icon>
                        </vs-button>
                      </div>
                      <div v-if="$store.state.uInfo.role !== 'U'" class="total-hours">
                        Total Hours:
                        <span
                          class="font-bold"
                        >{{convertToTime(totalActiveMinutesOfMonth)}}</span>
                      </div>
                      <!-- <label for="" class="vs-input--label float-right">Select Month</label> -->
                    </template>
                    <template slot="thead">
                      <vs-th class="sticky-col user-col">User</vs-th>
                      <vs-th
                        v-for="(dates,index) in MonthDates"
                        :key="index"
                        v-if="$store.state.uInfo.role !== 'U'"
                      >
                        {{ dates.Date }}
                        <br />
                        {{ dates.Day }}
                      </vs-th>
                      <vs-th
                        v-if="$store.state.uInfo.role !== 'U'"
                        class="sticky-col totaltime-col"
                      >Total Time</vs-th>
                    </template>

                    <template slot-scope="{data}">
                      <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td class="sticky-col user-col">
                          <div class="relative inline-flex float-left">
                            <!--<vs-avatar class="m-0" :src="require(`@/assets/images/portrait/small/avatar-s-11.png`)" size="40px"/>-->
                            <vs-avatar
                              class="m-0"
                              :src="tr.profile_image"
                              size="40px"
                              v-if="tr.profile_image"
                            />
                            <vs-avatar
                              color="primary"
                              class="m-0 name-avatar"
                              :text="usernameList(tr.firstname,tr.lastname)"
                              size="40px"
                              v-else
                            />
                            <div
                              class="h-3 w-3 border-white border border-solid rounded-full absolute pin-r pin-b"
                              :class="'bg-success'"
                            ></div>
                          </div>
                          <h6 class="mt-2 ml-16 break-words">{{ tr.user_name | capitalize }}</h6>
                        </vs-td>
                        <!-- TO DO Calendar Implement -->
                        <vs-td
                          v-for="(times,index) in tr.dateWiseData"
                          :key="index"
                          v-if="$store.state.uInfo.role !== 'U'"
                        >
                          <vx-tooltip text="View timesheet details">
                            <div class="time-box" @click="openSlidebar(tr.user_id,times.date)">
                              <span>{{convertToTime(times.activeMinutes)}}</span>
                            </div>
                          </vx-tooltip>
                        </vs-td>
                        <vs-td
                          v-if="$store.state.uInfo.role !== 'U'"
                          class="sticky-col totaltime-col"
                        >{{ convertToTime(tr.totalActiveMinutes) }}</vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </div>
                <div class="vx-col w-1/2">
                  <div class="justify-between flex mb-2">
                    <p>
                      Days worked:
                      <span class="font-bold">{{this.daysWorked}}</span>
                    </p>
                    <p>
                      Total Hours:
                      <span
                        class="font-bold"
                      >{{convertToTime(this.totalActiveMinutesOfMonth)}}</span>
                    </p>
                  </div>
                  <full-calendar
                    ref="calendar"
                    :event-sources="eventSources"
                    @event-selected="eventSelected"
                    :config="config"
                  ></full-calendar>
                </div>
              </div>
              <div></div>
            </vs-tab>
          </vs-tabs>
        </vs-tab>
        <vs-tab label="Daily Time Activity">
          <div>
            <form autocomplete="off">
              <div class="datepicker-main mb-4">
                <div class="datewrapper justify-end w-full" v-if="$store.state.uInfo.role !== 'U'">
                  <vs-input
                    icon-pack="feather"
                    icon="icon-search"
                    v-model="search"
                    class="w-auto mr-1"
                  />
                  <v-select
                    :clearable="false"
                    @input="changeOffice()"
                    class="w-auto mr-1  min-150"
                    label="office_name"
                    :options="allOffices"
                    v-model="officeID"
                  ></v-select>
                  <v-select
                    :clearable="false"
                    multiple
                    class="w-auto  min-150"
                    label="department_name"
                    :options="departments"
                    v-model="department_id"
                    @input="changeDept()"
                  ></v-select>
                </div>
              </div>
            </form>
          </div>
          <vs-tabs v-model="acivityTab" alignment="center" class="set_min_height all-tabs">
            <vs-tab label="Day">
              <div class="mt-5 mb-5 vx-row">
                <div class="flex justify-between mb-4 w-full mx-2">
                  <div class="datepicker-main">
                    <div class="datewrapper">
                      <label for class="float-right w-auto">Select Date</label>
                      <datepicker :calendar-button="true" calendar-button-icon="fa fa-calendar"
                        placeholder="Select Date"
                        class="float-right calendar-icon-right top-45"
                        format="dd/MM/yyyy"
                        v-model="currentDate"
                        @on-change="getNewDailyTimeSheet()"
                        :disabledDates="disabledDates"
                      ></datepicker>
                    </div>
                  </div>
                  <div>
                    <vue-json-to-csv :json-data="csvData" :csv-title="'DaysData'">
                      <vs-button :disabled="!userDayActivityData" class="gradient-btn">
                        <feather-icon icon="DownloadIcon" title="Download CSV" class></feather-icon>
                      </vs-button>
                    </vue-json-to-csv>
                    <vs-button
                      :disabled="!userDayActivityData"
                      class="ml-1 gradient-btn"
                      title="Download PDFs"
                      @click="generateDayPDF"
                    >
                      <feather-icon icon="FileTextIcon" class></feather-icon>
                    </vs-button>
                  </div>
                </div>
                <div :class="activeUserTable ? 'vx-col w-1/3' : 'vx-col w-full'">
                  <vs-table
                    id="my-table"
                    :data="searchresult"
                    :pagination="$store.state.uInfo.role !== 'U'"
                    :max-items="perPage1"
                    class="stickyCol-tbl dayinout-tbl activity-table"
                  >
                    <template slot="thead">
                      <vs-th class="sticky-col user-col">User</vs-th>
                    </template>

                    <template slot-scope="{data}">
                      <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td class="sticky-col user-col">
                          <div @click="openActivityTable(tr._id,currentDate)">
                            <div class="relative inline-flex float-left">
                              <vs-avatar
                                class="m-0"
                                :src="tr.profile_image"
                                size="40px"
                                v-if="tr.profile_image"
                              />
                              <vs-avatar
                                color="primary"
                                class="m-0 name-avatar"
                                :text="usernameList(tr.firstname,tr.lastname)"
                                size="40px"
                                v-else
                              />
                              <div
                                class="h-3 w-3 border-white border border-solid rounded-full absolute pin-r pin-b"
                                :class="'bg-success'"
                              ></div>
                            </div>
                            <h6 class="pt-3 ml-16 break-words">{{ tr.user_name | capitalize }}</h6>
                          </div>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </div>
                <div :class="activeUserTable ? 'vx-col w-2/3 show' : 'hide'">
                  <div class="vx-row status-table">
                    <div class="vx-col w-1/2">
                      <vs-table
                        v-model="activeUserTable"
                        class="activity-table"
                        v-if="userDayActivityData"
                        :data="userDayActivityData.users_data"
                      >
                        <template slot="thead">
                          <vs-th class="sticky-col user-col">Status</vs-th>
                          <vs-th class="sticky-col user-col">Time</vs-th>
                          <vs-th class="sticky-col user-col">Notes</vs-th>
                        </template>
                        <template slot-scope="{data}">
                          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td class="sticky-col user-col">{{ tr.status }}</vs-td>
                            <vs-td
                              class="sticky-col user-col"
                            >{{ tr.start_time | moment('h:mm a') }}</vs-td>
                            <vs-td class="sticky-col user-col">{{ tr.comment }}</vs-td>
                          </vs-tr>
                        </template>
                      </vs-table>
                    </div>
                    <div class="vx-col w-1/2">
                      <vs-table
                        v-model="activeUserTable"
                        class="activity-table"
                        v-if="userDayActivityData"
                        :data="responseOfProgressBar"
                        :disabled="true"
                      >
                        <template>
                          <vs-tr>
                            <vs-th>Total Time</vs-th>
                            <vs-td class="sticky-col user-col center-col"></vs-td>
                            <vs-td
                              class="sticky-col user-col"
                            >{{ convertToTime(responseOfProgressBar[0].totalActiveMinutes) }} hrs worked</vs-td>
                          </vs-tr>
                          <vs-tr>
                            <vs-th>Break/s</vs-th>
                            <vs-td class="sticky-col user-col center-col"></vs-td>
                            <vs-td
                              class="sticky-col user-col"
                            >{{responseOfProgressBar[0].totalBreakMinutes ? responseOfProgressBar[0].totalBreakMinutes : "0"}} hrs break</vs-td>
                          </vs-tr>
                          <vs-tr>
                            <vs-th>In</vs-th>
                            <vs-td class="sticky-col user-col center-col">4.5 hrs</vs-td>
                            <vs-td class="sticky-col user-col bg-success">55% IN</vs-td>
                          </vs-tr>
                          <vs-tr>
                            <vs-th>OUT</vs-th>
                            <vs-td class="sticky-col user-col center-col">4 hrs</vs-td>
                            <vs-td class="sticky-col user-col bg-warning">45% OUT</vs-td>
                          </vs-tr>
                        </template>
                      </vs-table>
                    </div>
                  </div>
                </div>
              </div>
            </vs-tab>
            <!-- Weeks activity -->
            <vs-tab label="Week">
              <div class="mt-5 mb-5 vx-row">
                <div class="vx-col w-full flex justify-between">
                  <div class="datepicker-main">
                    <div class="datewrapper">
                      <label for class="float-right w-auto">Select Week Date</label>
                      <datepicker :calendar-button="true" calendar-button-icon="fa fa-calendar"
                        placeholder="Select Date"
                        class="float-right calendar-icon-right top-45"
                        format="dd/MM/yyyy"
                        v-model="date"
                        @change="dateweek()"
                        :disabledDates="disabledDates"
                      ></datepicker>
                    </div>
                  </div>
                  <div>
                    <vue-json-to-csv :json-data="csvWeekData" :csv-title="'WeekData'">
                      <vs-button class="gradient-btn" :disabled="!userActivityData">
                        <feather-icon icon="DownloadIcon" title="Download CSV" class></feather-icon>
                      </vs-button>
                    </vue-json-to-csv>
                    <vs-button
                      class="mb-base ml-1 gradient-btn"
                      title="Download PDF"
                      :disabled="!userActivityData"
                      @click="generateActivityWeekPDF"
                    >
                      <feather-icon icon="FileTextIcon" class></feather-icon>
                    </vs-button>
                  </div>
                </div>
                <div class="justify-around flex w-full mb-2 font-bold">
                  <div v-for="(dates,index) in WeekDates" :key="index">
                    <p @click="activityIndex = index">
                      {{ dates.Date }}
                      <br />
                      {{ dates.Day }}
                    </p>
                  </div>
                </div>
                <div :class="activeUserTable ? 'vx-col w-1/3' : 'vx-col w-full'">
                  <vs-table
                    id="my-table"
                    :data="weeklySearchresult"
                    :pagination="$store.state.uInfo.role !== 'U'"
                    :max-items="perPage1"
                    class="stickyCol-tbl dayinout-tbl activity-table"
                  >
                    <template slot="thead">
                      <vs-th class="sticky-col user-col">User</vs-th>
                    </template>

                    <template slot-scope="{data}">
                      <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td class="sticky-col user-col">
                          <div @click="openWeekActivityTable(tr.user_id,currentDate)">
                            <div class="relative inline-flex float-left">
                              <vs-avatar
                                class="m-0"
                                :src="tr.profile_image"
                                size="40px"
                                v-if="tr.profile_image"
                              />
                              <vs-avatar
                                color="primary"
                                class="m-0 name-avatar"
                                :text="usernameList(tr.firstname,tr.lastname)"
                                size="40px"
                                v-else
                              />
                              <div
                                class="h-3 w-3 border-white border border-solid rounded-full absolute pin-r pin-b"
                                :class="'bg-success'"
                              ></div>
                            </div>
                            <h6 class="pt-3 ml-16 break-words">{{ tr.user_name | capitalize }}</h6>
                          </div>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </div>
                <div :class="activeUserTable ? 'vx-col w-2/3 show' : 'hide'">
                  <div class="vx-row">
                    <div class="vx-col w-1/2">
                      <vs-table
                        v-model="activeUserTable"
                        class="activity-table"
                        v-if="userActivityData"
                        :data="userActivityData[activityIndex].users_inOut"
                        :disabled="true"
                      >
                        <template slot="thead">
                          <vs-th class="sticky-col user-col">Status</vs-th>
                          <vs-th class="sticky-col user-col">Time</vs-th>
                          <vs-th class="sticky-col user-col">Notes</vs-th>
                        </template>
                        <template slot-scope="{data}">
                          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td class="sticky-col user-col">{{ tr.status }}</vs-td>
                            <vs-td
                              class="sticky-col user-col"
                            >{{ tr.start_time | moment('h:mm a') }}</vs-td>
                            <vs-td class="sticky-col user-col">{{ tr.comment }}</vs-td>
                          </vs-tr>
                        </template>
                      </vs-table>
                    </div>
                    <div class="vx-col w-1/2">
                      <vs-table
                        v-model="activeUserTable"
                        class="activity-table"
                        v-if="userActivityData"
                        :data="userActivityData.users_data"
                        :disabled="true"
                      >
                        <template>
                          <vs-tr>
                            <vs-th>Total Time</vs-th>
                            <vs-td class="sticky-col user-col center-col"></vs-td>
                            <vs-td class="sticky-col user-col">8.5 hrs worked</vs-td>
                          </vs-tr>
                          <vs-tr>
                            <vs-th>Break/s</vs-th>
                            <vs-td class="sticky-col user-col center-col"></vs-td>
                            <vs-td class="sticky-col user-col">1 hr break</vs-td>
                          </vs-tr>
                          <vs-tr>
                            <vs-th>In</vs-th>
                            <vs-td class="sticky-col user-col center-col">4.5 hrs</vs-td>
                            <vs-td class="sticky-col user-col bg-success">55% IN</vs-td>
                          </vs-tr>
                          <vs-tr>
                            <vs-th>OUT</vs-th>
                            <vs-td class="sticky-col user-col center-col">4 hrs</vs-td>
                            <vs-td class="sticky-col user-col bg-warning">45% OUT</vs-td>
                          </vs-tr>
                        </template>
                      </vs-table>
                    </div>
                  </div>
                </div>
              </div>
            </vs-tab>
          </vs-tabs>
        </vs-tab>
      </vs-tabs>
    </vx-card>
  </div>
</template>

<script>
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import VueJsonToCsv from "vue-json-to-csv";
import moment from "moment";
import jsPDF from "jspdf";
import "jspdf-autotable";
import "fullcalendar/dist/fullcalendar.css";
export default {
  components: {
    Datepicker,
    flatPickr,
    jsPDF,
    vSelect,
    "vue-json-to-csv": VueJsonToCsv
  },
  data() {
    return {
      tab: 0,
      acivityTab: 0,
      mainTab: 0,
      search: "",
      weekFlag: true,
      timezone: this.$store.state.uInfo.timeZone,
      deleteIndex: 0,
      addTimesheet: false,
      editTimesheet: false,
      deleteTimesheet: false,
      editTime: null,
      editTimeID: null,
      inTime: null,
      outTime: null,
      officeID: { office_name: "All Offices", id: "all" },
      allOffices: [],
      addStatus: null,
      addTime: null,
      comment: null,
      activityIndex: 0,
      InOutStatus: [
        {
          value: "IN",
          name: "In"
        },
        {
          value: "OUT",
          name: "Out"
        },
        {
          value: "CIN",
          name: "Clock In"
        },
        {
          value: "COUT",
          name: "Clock Out"
        },
        {
          value: "BI",
          name: "Break Start"
        },
        {
          value: "BS",
          name: "Break End"
        }
      ],
      configdateTimePicker: {
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        time_24hr: false
      },
      disabledDates: {
        from: new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          new Date().getDate() + 1
        ) // Disable all dates after specific date
      },
      active: false,
      activeUserTable: false,
      perPage: 25,
      totalPage: 1,
      currentPage: 1,
      perPage1: 25,
      totalPage1: 1,
      currentPage1: 1,
      status: "A",
      switch1: true,
      MonthlyTimeSheet: [],
      WeeklyTimeSheet: [],
      DailyTimeSheet: [],
      searchresult: [],
      weeklySearchresult: [],
      monthlySearchresult: [],
      MonthDates: [],
      WeekDates: [],
      userID: null,
      addTimeDate: null,
      editTimeDate: null,
      currentDate: new Date(),
      currentMonth: new Date(),
      date: new Date(),
      recordList: [
        {
          text: 25,
          value: 25
        },
        {
          text: 50,
          value: 50
        },
        {
          text: 100,
          value: 100
        },
        {
          text: 250,
          value: 250
        }
      ],
      config: {
        defaultView: "month",
        eventClick: event => {
          this.selected = event;
          this.openSlidebar(this.MonthlyTimeSheet[0].user_id, event.date);
        }
      },
      selected: {},
      format: "dd/MM/yyyy",
      sidebarUserData: null,
      userActivityData: null,
      userDayActivityData: null,
      currentTime: null,
      totalActiveMinutesOfMonth: null,
      totalActiveMinutesOfWeek: null,
      csvData: [],
      csvWeekData: [],
      csvMonthData: [],
      collapseFlag: false,
      daysWorked: null,
      flag: false,
      responseOfProgressBar: [],
      departments: [],
      departmentsAll: [],
      department_id: [{ department_name: "All Departments", id: "all" }]
    };
  },
  mounted: function() {
    this.getOffice();
    // this.getOffice();
    setTimeout(() => {
      this.liveInOutStatus();
      this.getMonthlyDate();
      this.getMonthlyTimeSheet();
      this.dateweek();
      this.getNewDailyTimeSheet();
    }, 2000);
  },
  watch: {
    currentPage(nv) {
      if (nv) {
        this.getItems();
      }
    },
    perPage(nv) {
      if (nv) {
        this.getItems();
      }
    },
    currentPage1(nv) {
      if (nv) {
        this.getItems();
      }
    },
    perPage1(nv) {
      if (nv) {
        this.getItems();
      }
    },
    date(nv) {
      if (nv) {
        this.dateweek();
      }
    },
    currentMonth(nv) {
      if (nv) {
        this.getMonthlyDate();
        this.getMonthlyTimeSheet();
      }
    },
    currentDate(nv) {
      if (nv) {
        this.getNewDailyTimeSheet();
        this.CloseActivityTable();
      }
    },
    search(nv) {
      if (!nv) {
        this.perPage = 25;
        this.currentPage = 1;
        if (this.$refs.paginationApplication) {
          this.$refs.paginationApplication.current = 1;
        }
        // this.getItems();
      }
      if (nv) {
        if (this.mainTab == 0) {
          if (this.tab == 0) {
            let result = this.DailyTimeSheet.filter(e => {
              if (
                e.firstname.toLowerCase().includes(this.search.toLowerCase()) ||
                e.lastname.toLowerCase().includes(this.search.toLowerCase())
              ) {
                return true;
              } else {
                return false;
              }
            });
            this.searchresult = result;
          } else if (this.tab == 1) {
            let result1 = this.WeeklyTimeSheet.filter(e => {
              if (
                e.firstname.toLowerCase().includes(this.search.toLowerCase()) ||
                e.lastname.toLowerCase().includes(this.search.toLowerCase())
              ) {
                return true;
              } else {
                return false;
              }
            });
            this.weeklySearchresult = result1;
          } else {
            let result2 = this.MonthlyTimeSheet.filter(e => {
              if (
                e.firstname.toLowerCase().includes(this.search.toLowerCase()) ||
                e.lastname.toLowerCase().includes(this.search.toLowerCase())
              ) {
                return true;
              } else {
                return false;
              }
            });
            this.monthlySearchresult = result2;
          }
        } else {
          // Daily Activity
          if (this.acivityTab == 0) {
            let result = this.DailyTimeSheet.filter(e => {
              if (
                e.firstname.toLowerCase().includes(this.search.toLowerCase()) ||
                e.lastname.toLowerCase().includes(this.search.toLowerCase())
              ) {
                return true;
              } else {
                return false;
              }
            });
            this.searchresult = result;
          } else if (this.acivityTab == 1) {
            let result1 = this.WeeklyTimeSheet.filter(e => {
              if (
                e.firstname.toLowerCase().includes(this.search.toLowerCase()) ||
                e.lastname.toLowerCase().includes(this.search.toLowerCase())
              ) {
                return true;
              } else {
                return false;
              }
            });
            this.weeklySearchresult = result1;
          }
        }
      }
    }
  },
  computed: {
    eventSources() {
      const self = this;
      return [
        {
          events(start, end, timezone, callback) {
            setTimeout(() => {
              callback(
                self.MonthlyTimeSheet[0].dateWiseData.map(d => {
                  return {
                    ...d,
                    start: d.date,
                    title: self.convertToTime(d.activeMinutes).toString(),
                    allDay: true
                  };
                })
              );
            }, 1000);
          }
        }
      ];
    }
  },
  methods: {
    refreshEvents() {
      this.$refs.calendar.$emit("refetch-events");
    },
    removeEvent() {
      this.$refs.calendar.$emit("remove-event", this.selected);
      this.selected = {};
    },
    eventSelected(event) {
      this.selected = event;
    },

    generateDayPDF() {
      const doc = new jsPDF();
      var finalY = doc.lastAutoTable.finalY || 10;
      doc.text("DayWise Data of User", 14, finalY + 15);
      doc.autoTable({
        body: this.csvData,
        startY: finalY + 20,
        columns: [
          { header: "User", dataKey: "User" },
          { header: "Status", dataKey: "Status" },
          { header: "Start Time", dataKey: "StartTime" },
          { header: "Notes", dataKey: "Comment" }
        ]
      });
      doc.save("DaysData.pdf");
    },
    generatePDF() {
      const doc = new jsPDF();
      var finalY = doc.lastAutoTable.finalY || 10;
      doc.text("DayWise Data of User", 14, finalY + 15);
      doc.autoTable({
        body: this.csvData,
        startY: finalY + 20,
        columns: [
          { header: "User", dataKey: "User" },
          { header: "Clock ON", dataKey: "Clock ON" },
          { header: "Clock OFF", dataKey: "Clock OFF" },
          { header: "Total Time", dataKey: "Total Time" },
          { header: "Break Start", dataKey: "Break Start" },
          { header: "Break End", dataKey: "Break End" },
          { header: "Break Total", dataKey: "Break Total" }
        ]
      });
      doc.save("DaysData.pdf");
    },
    generateWeekPDF() {
      const doc = new jsPDF();
      var finalY = doc.lastAutoTable.finalY || 10;
      doc.text("WeekWise Data of User", 14, finalY + 15);
      let columns = [];
      this.csvWeekData.forEach(w => {
        var keys = Object.keys(w);
        keys.forEach(k => {
          columns.push({ header: k, dataKey: k });
        });
      });
      doc.autoTable({
        body: this.csvWeekData,
        startY: finalY + 20,
        columns
      });
      doc.save("WeekData.pdf");
    },
    generateActivityWeekPDF() {
      const doc = new jsPDF();
      var finalY = doc.lastAutoTable.finalY || 10;
      doc.text("WeekWise Data of User", 14, finalY + 15);
      doc.autoTable({
        body: this.csvWeekData,
        startY: finalY + 20,
        columns: [
          { header: "User", dataKey: "User" },
          { header: "Date", dataKey: "Date" },
          { header: "Status", dataKey: "Status" },
          { header: "Start Time", dataKey: "Start Time" },
          { header: "Notes", dataKey: "Notes" }
        ]
      });
      doc.save("WeekData.pdf");
    },
    generateActivityMonthPDF() {
      const doc = new jsPDF();
      var finalY = doc.lastAutoTable.finalY || 10;
      doc.text("WeekWise Data of User", 14, finalY + 15);
      doc.autoTable({
        body: this.csvWeekData,
        startY: finalY + 20,
        columns: [
          { header: "User", dataKey: "User" },
          { header: "Date", dataKey: "Date" },
          { header: "Status", dataKey: "Status" },
          { header: "Start Time", dataKey: "Start Time" },
          { header: "Notes", dataKey: "Notes" }
        ]
      });
      doc.save("MonthData.pdf");
    },
    generateMonthPDF() {
      const doc = new jsPDF();
      var finalY = doc.lastAutoTable.finalY || 10;
      doc.text("MonthWise Data of User", 14, finalY + 15);
      let columns = [];
      this.csvMonthData.forEach(w => {
        var keys = Object.keys(w);
        keys.forEach(k => {
          columns.push({ header: k, dataKey: k });
        });
      });
      doc.autoTable({
        body: this.csvMonthData,
        startY: finalY + 20,
        columns,
        tableWidth: "wrap",
        styles: { cellPadding: 0.5, fontSize: 8, overflow: "linebreak" }
      });
      doc.save("MonthData.pdf");
    },
    printInvoice() {
      window.print();
    },
    findLength(arr) {
      if (arr.length) {
        let largest = arr[0];
        for (var i = 0; i < arr.length; i++) {
          if (largest.inout.length < arr[i].inout.length) {
            largest = arr[i];
          }
        }
        return largest.inout.length;
      } else {
        return 2;
      }
    },
    usernameList(firstname, lastname) {
      if (firstname && lastname) {
        let first = firstname.trim().charAt(0);
        let last = lastname.trim().charAt(0);
        let name = first.concat(last);
        return name.toUpperCase();
      }
      /*  return firstname.trim() + " " + lastname.trim(); */
    },
    checkTimesheetDate(startDate, currentDate) {
      if (startDate) {
        let current = moment(currentDate).format("DD/MM/YYYY");
        let start_date = moment(startDate).format("DD/MM/YYYY");
        if (current == start_date) {
          return true;
        } else {
          return false;
        }
      }
      return false;
    },
    getDept() {
      this.$vs.loading({
        color: "primary"
      });

      let url = `dept/getAll?office_id=${this.officeID.id}`;
      this.axios
        .get(url)
        .then(response => {
          let data = response.data.data;
          this.departments = data;
          this.departmentsAll = data;
          this.$vs.loading.close();
        })
        .catch(e => {
          this.showError(e);
        });
    },
    changeDept() {
      this.getMonthlyDate();
      this.getMonthlyTimeSheet();
      this.dateweek();
      this.getNewDailyTimeSheet();
    },
    changeOffice() {
      this.getDept();
      this.getMonthlyDate();
      this.getMonthlyTimeSheet();
      this.dateweek();
      this.getNewDailyTimeSheet();
    },
    getOffice() {
      this.$vs.loading({
        color: "primary"
      });

      let url = "office/getAll";
      this.axios
        .get(url)
        .then(response => {
          this.$vs.loading.close();
          let data = response.data.data;
          this.allOffices = data;
        })
        .catch(e => {
          this.showError(e);
        });
    },
    getTime() {
      var d = new Date();
      var date = d.getTime();
      this.currentTime = moment
        .tz(date)
        .startOf("date")
        .valueof();
    },
    openAddForm() {
      this.addTimesheet = true;
    },
    cancelAddForm() {
      this.addTime = null;
      this.addStatus = null;
      this.comment = null;
      this.addTimesheet = false;
      this.editTimesheet = false;
      this.deleteTimesheet = false;
    },
    editTimeForm(tr) {
      this.addTimesheet = false;
      this.deleteTimesheet = false;
      this.editTimesheet = true;
      this.editTime = moment.tz(tr.start_time, this.timezone).format('HH:mm');
      this.editTimeID = tr._id;
    },
    addTimeData() {
      this.$validator.validateAll("addtimesheet-form").then(result => {
        if (result) {
          let input = {
            from_time: this.addTime,
            user_id: this.userID,
            date: moment(this.addTimeDate).format("DD/MM/YYYY"),
            status: this.addStatus,
            comment: this.comment
          };
          this.$vs.loading({
            color: "primary"
          });

          this.axios
            .put("inout/addTimeSheet", input)
            .then(response => {
              this.$vs.loading.close();

              let data = response.data.data;
              // let uDate  = moment(data.data.smart_time).zone(timezone).format('DD/MM/YYYY');
              let uDate = moment.tz(data.data.start_time, this.timezone).valueOf();
              let uID = data.data.user_id;

              var text = "Timesheet has been added successfully!!!";

              this.$vs.notify({
                text: text,
                color: "success",
                position: "top-right"
              });
              this.cancelAddForm();
              this.openSlidebar(uID, uDate);
              this.openActivityTable(uID, uDate);
              this.changeOffice();
            })
            .catch(e => {
              this.showError(e);
            });
        }
      });
    },
    editTimeData() {
      let input = {
        id: this.editTimeID,
        date: moment(this.editTimeDate).format("DD/MM/YYYY"),
        time: this.editTime,
        comment: this.comment
      };
      this.$vs.loading({
        color: "primary"
      });

      this.axios
        .put("inout/editTimeSheet", input)
        .then(response => {
          this.$vs.loading.close();

          let data = response.data.data;
          // let uDate  = moment(data.data.smart_time).zone(data.timeZone).format('DD/MM/YYYY');
          let uDate = moment.tz(data.data.start_time, this.timezone).valueOf();
          let uID = data.data.user_id;

          var text = "Timesheet has been updated successfully!!!";

          this.$vs.notify({
            text: text,
            color: "success",
            position: "top-right"
          });
          this.editTimesheet = null;
          this.editTime = null;
          this.editTimeID = null;
          this.editTimeDate = null;
          this.openSlidebar(uID, uDate);
          this.openActivityTable(uID, uDate);
          this.changeOffice();
        })
        .catch(e => {
          this.showError(e);
        });
    },
    cancelEditForm() {
      this.editTimesheet = false;
      this.editTime = null;
      this.editTimeID = null;
    },
    CloseSlidebar() {
      this.active = false;
    },
    CloseActivityTable() {
      this.activeUserTable = false;
    },
    openSlidebar(userID, userDate) {
      let current = moment(this.currentDate).format("DD/MM/YYYY");
      let f_date = moment(userDate).format("DD/MM/YYYY");

      if (this.currentDate.valueOf() < moment(userDate).valueOf()) {
        return;
      }

      this.$vs.loading({
        color: "primary"
      });
      let date = moment.tz(userDate, this.timezone).format("DD/MM/YYYY");

      let url = "inout/getDailyTimeSheet?records=records";
      url += "&date=" + date;
      url += "&user_id=" + userID;

      this.axios
        .get(url)
        .then(response => {
          this.$vs.loading.close();
          let data = response.data.data;
          if (data.data.length != 0) {
            this.sidebarUserData = data.data[0];
            this.sidebarUserData.timeZone = data.timeZone;
            this.userID = userID;
            this.addTimeDate = userDate;
            this.editTimeDate = userDate;
            this.active = true;
            this.cancelAddForm();
          } else {
            let error = "Records not found";
            this.$vs.notify({
              text: error,
              color: "danger",
              position: "top-right"
            });
            this.sidebarUserData = [];
          }
        })
        .catch(e => {
          this.showError(e);
        });
      // this.active = true;
    },

    /**
     * @function openWeekActivityTable
     */
    openWeekActivityTable(userID, userDate) {
      // let current = moment(this.currentDate).format("DD/MM/YYYY");
      // let f_date = moment(userDate).format("DD/MM/YYYY");

      if (this.currentDate.valueOf() < moment(userDate).valueOf()) {
        return;
      }

      this.$vs.loading({
        color: "primary"
      });
      let date = moment.tz(this.date, this.timezone).format("DD/MM/YYYY");
      let url = "inout/getWeeklyTimeSheet";
      url += "?fromDate=" + date;
      url += "&user_id=" + userID;

      this.axios
        .get(url)
        .then(response => {
          this.$vs.loading.close();
          let data = response.data.data;

          this.userActivityData = data[0].dateWiseData;
         
          this.userActivityData.timeZone = data.timeZone;
          this.userID = userID;
          this.addTimeDate = userDate;
          this.editTimeDate = userDate;
          this.activeUserTable = true;
          this.csvWeekData = [];
          if (data.length != 0) {
            for (let i = 0; i < this.userActivityData.length; i++) {
              const element = this.userActivityData[i];
              for (let j = 0; j < element.users_inOut.length; j++) {
                let myobj = {};
                const io = element.users_inOut[j];
                myobj.User = data[0].firstname + " " + data[0].lastname;
                myobj.Date = `${this.WeekDates[i].Date} ${this.WeekDates[i].Day}`;
                myobj.Status = io.status;
                myobj["Start Time"] = moment.tz(io.start_time, this.timezone).format("HH:mm");
                myobj.Notes = io.comment;
                this.csvWeekData.push(myobj);
              }
            }

          } else {
            let error = "Records not found";
            this.$vs.notify({
              text: error,
              color: "danger",
              position: "top-right"
            });
            // this.userActivityData = [];
          }
        })
        .catch(e => {
          this.showError(e);
        });
    },
    openActivityTable(userID, userDate) {
      let current = moment(this.currentDate).format("DD/MM/YYYY");
      let f_date = moment(userDate).format("DD/MM/YYYY");

      if (this.currentDate.valueOf() < moment(userDate).valueOf()) {
        return;
      }

      this.$vs.loading({
        color: "primary"
      });

      let date = moment.tz(userDate, this.timezone).format("DD/MM/YYYY");
      let url = "";

      url = "inout/getDailyTimeSheet?";
      url += "&date=" + date;
      url += "&mobile=true&fromFront=true&records=records";
      url += "&user_id=" + userID;

      this.axios
        .get(url)
        .then(response => {
          this.$vs.loading.close();
          let data = response.data.data.data;
          if (data.data.length != 0) {
            this.userDayActivityData = data.data[0];

            this.responseOfProgressBar =
              response.data.data.responseOfProgressBar;
            // this.userDayActivityData.timeZone = data.timeZone;
            this.userID = userID;
            this.addTimeDate = userDate;
            this.editTimeDate = userDate;
            this.activeUserTable = true;
            this.csvData = [];
            for (
              let i = 0;
              i < this.userDayActivityData.users_data.length;
              i++
            ) {
              const element = this.userDayActivityData.users_data[i];

              let myobj = {
                User:
                  this.userDayActivityData.firstname +
                  " " +
                  this.userDayActivityData.lastname,
                Status: element.status,
                StartTime: moment.tz(element.start_time, this.timezone).format("HH:mm"),
                Comment: element.comment
              };
              this.csvData.push(myobj);
            }
          } else {
            let error = "Records not found";
            this.$vs.notify({
              text: error,
              color: "danger",
              position: "top-right"
            });
            this.userDayActivityData = [];
          }
        })
        .catch(e => {
          this.showError(e);
        });
    },
    dateweek() {
      let date = this.date;
      let result = [];
      for (let i = 1; i <= 7; i++) {
        let s = moment(date).isoWeekday(i);
        result.push({
          Date: moment(s).format("MMM DD"),
          Day: moment(s).format("ddd")
        });
      }
      this.WeekDates = result;
      this.getWeeklyTimeSheet();
    },

    getMonthlyDate() {
      let monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "April",
        "May",
        "Jun",
        "Jul",
        "Augt",
        "Sep",
        "October",
        "Nov",
        "Dec"
      ];
      let d = new Date();
      let year = d.getFullYear();
      let month = moment(this.currentMonth).format("MM") - 1;
      let names = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
      let date = new Date(year, month, 1);
      let DayAndDate = [];
      let result = [];
      while (date.getMonth() == month) {
        //
        let dd = date.getDate() + " " + monthNames[date.getMonth()];
        result.push({
          Date: dd,
          Day: names[date.getDay()]
        });
        date = new Date(year, month, date.getDate() + 1);
        // DayAndDate.setDate(date.getDate() + 1);
      }
      this.MonthDates = result;
    },

    convertToTime(totalMinutes) {
      if (totalMinutes) {
        const addZero = d => (d > 9 ? d.toString() : "0" + d.toString());
        let hours = addZero(Math.floor(totalMinutes / 60));
        let minutes = addZero(totalMinutes % 60);

        return hours + ":" + minutes;
      } else {
        return "00:00";
      }
    },
    getDailyTimeSheet() {
      this.$vs.loading({
        color: "primary"
      });

      let date = moment.tz(this.currentDate, this.timezone).format("DD/MM/YYYY");

      // let url = "inout/getDailyTimeSheet";
      let url = "inout/getDailyTimeSheetProcess";

      url += "?date=" + date;
      if (this.$store.state.uInfo.role == "U") {
        url += "&user_id=" + this.$store.state.uInfo.id;
      } else {
        url += "&office_id=" + this.officeID.id;
      }

      this.axios
        .get(url)
        .then(response => {
          this.$vs.loading.close();
          let data = response.data.data;
          if (data.length != 0) {
            this.DailyTimeSheet = data;
          } else {
            this.DailyTimeSheet = [];
          }
        })
        .catch(e => {
          this.showError(e);
        });
    },
    getNewDailyTimeSheet() {
      this.$vs.loading({
        color: "primary"
      });

      let date = moment.tz(this.currentDate, this.timezone).format("DD/MM/YYYY");
      
      let d_data = [];
      this.department_id &&
        this.department_id.map(element => {
          d_data.push(element.id);
        });
    
      // let url = "inout/getDailyTimeSheet";
      let url = "inout/getDailyTimeSheetMobile";

      url += "?date=" + date + "&mobile=true&fromFront=true&records=records";
      if (this.$store.state.uInfo.role == "U") {
        url += "&user_id=" + this.$store.state.uInfo.id;
      } else {
        url += "&office_id=" + this.officeID.id;
        url += "&department_id=" + d_data;
      }

      this.axios
        .get(url)
        .then(response => {
          this.$vs.loading.close();
          let data = response.data.data;
          let responseOfProgressBar = data.responseOfProgressBar;
          let responseOftimesheet = data.data;
       
          // if (data.length != 0) {
          //     this.DailyTimeSheet = data.data;
          // } else {
          //     this.DailyTimeSheet = [];
          // }

          let timesheetData = [];
          responseOftimesheet.data.forEach(element => {
            let userData = [];
            let current = moment(this.currentDate).format("DD/MM/YYYY");
            element.users_data.forEach(element => {
              let start_date = moment(element.start_time).format("DD/MM/YYYY");
              if (current == start_date) {
                userData.push(element);
              }
            });

            element.cin = null;
            element.cout = null;
            element.bi = null;
            element.bs = null;
            element.totalActiveMinutes = 0;
            element.totalBreakMinutes = 0;

            let inout = [];
            if (userData.length != 0) {
              for (let i = 0; i < userData.length; i++) {
                if (userData[i].is_clockedIn && !element.cin) {
                  element.cin = userData[i];
                  //   userData.splice(i, 1);
                } else if (userData[i].is_clockedOut) {
                  element.cout = userData[i];
                } else if (userData[i].status == "BI") {
                  element.bi = userData[i];
                } else if (userData[i].status == "BS") {
                  element.bs = userData[i];
                } else {
                  inout.push(userData[i]);
                }
              }
            }
            element.inout = inout;

            /* find total actvie & break time */
            let filter = responseOfProgressBar.findIndex(
              x => x.user_id === element._id
            );
            if (filter >= 0) {
              element.totalActiveMinutes =
                responseOfProgressBar[filter].totalActiveMinutes;
              element.totalBreakMinutes =
                responseOfProgressBar[filter].totalBreakMinutes;
            }
            /* find total actvie & break time */

            timesheetData.push(element);
          });

          /* stat check inout length */
          let len = timesheetData[0].inout.length;
          timesheetData.forEach(el => {
            if (el.inout.length > len) {
              len = el.inout.length;
            }
          });
          /* end check inout length  */

          if (len) {
            timesheetData.forEach(ell => {
              for (let q = 0; q < len; q++) {
                if (!ell.inout[q]) {
                  ell.inout[q] = {
                    is_blank: false
                  };
                }
              }
            });
          } else {
            timesheetData.forEach(ell => {
              for (let q = 0; q < 4; q++) {
                if (!ell.inout[q]) {
                  ell.inout[q] = {
                    is_blank: false
                  };
                }
              }
            });
          }
          this.DailyTimeSheet = timesheetData;
          this.searchresult = this.DailyTimeSheet;

          for (let i = 0; i < timesheetData.length; i++) {
            const element = timesheetData[i];
            const cout_time =
              element.cout && element.cout.start_time
                ? moment(element.cout.start_time).format("hh:mm a")
                : "00:00";
            const cin_time =
              element.cin && element.cin.start_time
                ? element.cin.start_time.format("hh:mm a")
                : "00:00";
            const bi_time =
              element.bi && element.bi.start_time
                ? moment(element.bi.start_time).format("hh:mm a")
                : "00:00";
            const bs_time =
              element.bs && element.bs.start_time
                ? moment(element.bs.start_time).format("hh:mm a")
                : "00:00";
            const break_total = element.totalBreakMinutes
              ? this.convertToTime(element.totalBreakMinutes)
              : "00:00";
            const total_time = element.totalActiveMinutes
              ? this.convertToTime(element.totalActiveMinutes)
              : "00:00";
            let myobj = {
              User: element.firstname + " " + element.lastname,
              "Clock ON": cin_time,
              "Clock OFF": cout_time,
              "Total Time": total_time,
              "Break Start": bi_time,
              "Break End": bs_time,
              "Break Total": break_total
            };
            this.csvData.push(myobj);
          }
        })
        .catch(e => {
          this.showError(e);
        });
    },
    getWeeklyTimeSheet() {
      this.$vs.loading({
        color: "primary"
      });

      let date = moment.tz(this.date, this.timezone).format("DD/MM/YYYY"); 

      let url = "inout/getWeeklyTimeSheet";
      url += "?fromDate=" + date;
      if (this.$store.state.uInfo.role == "U") {
        url += "&user_id=" + this.$store.state.uInfo.id;
      } else {
        url += "&office_id=" + this.officeID.id;
      }

      this.axios
        .get(url)
        .then(response => {
          this.$vs.loading.close();
          let data = response.data.data;

          this.WeeklyTimeSheet = data.responseOfWeeklyTimeSheet;
          this.weeklySearchresult = data.responseOfWeeklyTimeSheet;
          this.totalPage = Math.ceil(data.count / this.perPage);
          this.totalActiveMinutesOfWeek = data.totalUserWorkedMinutes;
          for (let j = 0; j < this.WeeklyTimeSheet.length; j++) {
            const parentElement = this.WeeklyTimeSheet[j];
            let myobj = {};
            myobj.User = parentElement.firstname + " " + parentElement.lastname;

            for (let i = 0; i < parentElement.dateWiseData.length; i++) {
              const element = parentElement.dateWiseData[i];

              myobj[
                `${this.WeekDates[i].Date} ${this.WeekDates[i].Day}`
              ] = this.convertToTime(element.activeMinutes);
            }
            this.csvWeekData.push(myobj);
          }
        })
        .catch(e => {
          this.showError(e);
        });
    },
    getMonthlyTimeSheet() {
      this.$vs.loading({
        color: "primary"
      });

      let month = moment.tz(this.currentMonth, this.timezone).format("MM");

      let url = "inout/getMonthlyTimeSheet";
      url += "?month=" + month;
      if (this.$store.state.uInfo.role == "U") {
        url += "&user_id=" + this.$store.state.uInfo.id;
      } else {
        url += "&office_id=" + this.officeID.id;
      }

      this.axios
        .get(url)
        .then(response => {
          this.$vs.loading.close();
          let data = response.data.data;
          this.MonthlyTimeSheet = data.responseOfMonthlyTimeSheet;
          this.monthlySearchresult = data.responseOfMonthlyTimeSheet;
          this.totalActiveMinutesOfMonth = data.totalActiveMinutes;
          this.totalPage = Math.ceil(
            data.responseOfMonthlyTimeSheet.count / this.perPage
          );
          this.totalActiveMinutesOfMonth = data.totalUserWorkedMinutes;
          this.daysWorked = data.totalWorkingDays;
          for (let j = 0; j < this.MonthlyTimeSheet.length; j++) {
            const parentElement = this.MonthlyTimeSheet[j];
            let myobj = {};
            myobj.User = parentElement.firstname + " " + parentElement.lastname;

            for (let i = 0; i < parentElement.dateWiseData.length; i++) {
              const element = parentElement.dateWiseData[i];

              myobj[
                `${this.MonthDates[i].Date} ${this.MonthDates[i].Day}`
              ] = this.convertToTime(element.activeMinutes);
            }
            this.csvMonthData.push(myobj);
          }
        })
        .catch(e => {
          this.showError(e);
        });
    },
    confirmDelete(index) {
      this.addTimesheet = false;
      this.editTimesheet = false;
      this.deleteTimesheet = false;
      setTimeout(() => {
        this.deleteIndex = index;
        this.deleteTimesheet = true;
      }, 100);
    },
    cancleDelete() {
      this.deleteIndex = 0;
      this.deleteTimesheet = false;
    },
    deleteTimeSheet() {
      let input = {
        // data: {
        id: this.deleteIndex
        // }
      };
      this.$vs.loading({
        color: "primary"
      });
      this.axios
        .put("inout/deleteTimeSheet", input)
        .then(response => {
          this.$vs.loading.close();
          let text = "Timesheet has been deleted successfully!!!";
          this.$vs.notify({
            text: text,
            color: "success",
            position: "top-right"
          });
          this.deleteIndex = 0;
          this.deleteTimesheet = false;

          let data = response.data.data;
          let uDate = moment.tz(data.data.start_time, this.timezone).valueOf();
         
          let uID = data.data.user_id;
          this.openSlidebar(uID, uDate);
          this.changeOffice();
        })
        .catch(e => {
          this.deleteIndex = 0;
          this.showError(e);
        });
      this.$vs.loading.close();
    }
  }
};
</script>

<style>
.fc-today-button,
.fc-month-button,
.fc-agendaWeek-button,
.fc-agendaDay-button {
  display: none !important;
}
.application-action {
  float: left !important;
}

.time-box {
  background-color: lightgrey;
  width: 100px;
  border: 1px black;
  padding: 5px;
  margin: 2px;
  text-align: center;
  float: left;
}

.vs-table--tbody {
  z-index: 1 !important;
}

.vdp-datepicker {
  z-index: 2;
}

.vdp-datepicker__calendar {
  right: 0;
}

.tooltip {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}

/* .datepicker-main {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
    } */
.datepicker-main {
  display: flex;
  align-items: center;
  width: auto;
}
.datewrapper {
  display: flex;
}

.datewrapper label {
  float: right;
  text-align: right;
  line-height: 40px;
  padding-right: 10px;
  font-size: 14px !important;
  font-weight: bold;
}

.sidesheet .vs-sidebar {
  max-width: 450px !important;
  z-index: 99999 !important;
}
.total-hours {
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding: 0.7rem;
  border-radius: 5px;
  margin-bottom: 10px;
}
.vs-table--search {
  margin: 0 !important;
}
.feather-download,
.feather-printer,
.feather-file-text {
  width: 16px;
  height: 16px;
}
.activity-table {
  max-height: 300px;
  overflow-x: auto;
}
.center-col {
  border-left: 1px solid #e7e7e7 !important;
  border-right: 1px solid #e7e7e7 !important;
}
.fc-toolbar h2 {
  font-size: 18px;
  font-weight: 700;
  color: #666;
}
.fc-event,
.fc-event-dot {
  background-color: #3aad68;
}
.fc-event .fcc-content {
  padding-left: 3px;
}
.fc-unthemed td.fc-today {
  background: #3f57fe;
  color: #fff;
}
.fc-unthemed td.fc-past {
  background: #ff9000;
}
.fc-toolbar {
  text-align: right;
}
.hide {
  display: none;
}
.activity-table .header-table {
  justify-content: flex-end !important;
}
.status-table {
  margin-top: 58px;
}
</style>

<style lang="scss">
.sidesheet .vs-sidebar--background {
  z-index: 99999 !important;
}

.sidesheet .header-sidebar {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;

  h4 {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;

    > button {
      margin-left: 10px;
    }
  }
}

.sidesheet .footer-sidebar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  > button {
    border: 0px solid rgba(0, 0, 0, 0) !important;
    border-left: 1px solid rgba(0, 0, 0, 0.07) !important;
    border-radius: 0px !important;
  }
}

.delete-timesheet {
  margin: 16px 0px;
  padding: 0px 20px;
}

.sidesheet .vs-sidebar--items {
  height: 756px;
  overflow-y: scroll;
}
.vs-table .vs-table--thead .td-check{
  width: 1%;
}
.td-check{width: 1%;}
</style>